import { NgModule } from '@angular/core';
import { NoPreloading, PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { ButtonsComponent } from './buttons/buttons.component';
import { ColorsComponent } from './colors/colors.component';
import { ComponentsComponent } from './components/components.component';
import { DialogModalComponent } from './dialog-modal/dialog-modal.component';
import { FormControlsComponent } from './form-controls/form-controls.component';
import { IconsComponent } from './icons/icons.component';
import { LayoutComponent } from './layout/layout.component';
import { NavigationComponent } from './navigation/navigation.component';
import { NewColorsComponent } from './new-colors/new-colors.component';
import { NewTypographyComponent } from './new-typography/new-typography.component';
import { PlatformActionTickerComponent } from './platform-action-ticker/platform-action-ticker.component';
import { PlatformButtonComponent } from './platform-button/platform-button.component';
import { PlatformCheckboxComponent } from './platform-checkbox/platform-checkbox.component';
import { PlatformDatepickerComponent } from './platform-datepicker/platform-datepicker.component';
import { PlatformDrawerComponent } from './platform-drawer/platform-drawer.component';
import { PlatformInputComponent } from './platform-input/platform-input.component';
import { PlatformMenuComponent } from './platform-menu/platform-menu.component';
import { PlatformMessageComponent } from './platform-message/platform-message.component';
import { PlatformProgressIndicatorComponent } from './platform-progress-indicator/platform-progress-indicator.component';
import { PlatformRangepickerComponent } from './platform-rangepicker/platform-rangepicker.component';
import { PlatformSelectComponent } from './platform-select/platform-select.component';
import { PlatformStateIndicatorComponent } from './platform-state-indicator/platform-state-indicator.component';
import { PlatformStatusMarkerComponent } from './platform-status-marker/platform-status-marker.component';
import { PlatformSwitchComponent } from './platform-switch/platform-switch.component';
import { PlatformTabsComponent } from './platform-tabs/platform-tabs.component';
import { TypographyComponent } from './typography/typography.component';

import { environment } from '../../../admin/src/environments/environment';
import { PlatformThemeResolver } from '../../../shared/resolvers/platform-theme.resolver';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'typography',
    pathMatch: 'full'
  },
  {
    path: 'typography',
    component: TypographyComponent
  },
  {
    path: 'new-typography',
    component: NewTypographyComponent
  },
  {
    path: 'colors',
    component: ColorsComponent
  },
  {
    path: 'new-colors',
    component: NewColorsComponent
  },
  {
    path: 'form-controls',
    component: FormControlsComponent
  },
  {
    path: 'layout',
    component: LayoutComponent
  },
  {
    path: 'buttons',
    component: ButtonsComponent
  },
  {
    path: 'navigation',
    component: NavigationComponent
  },
  {
    path: 'dialog-modal',
    component: DialogModalComponent
  },
  {
    path: 'icons',
    component: IconsComponent
  },
  {
    path: 'platform-button',
    component: PlatformButtonComponent,
    resolve: { theme: PlatformThemeResolver }
  },
  {
    path: 'platform-menu',
    component: PlatformMenuComponent,
    resolve: { theme: PlatformThemeResolver }
  },
  {
    path: 'platform-drawer',
    component: PlatformDrawerComponent,
    resolve: { theme: PlatformThemeResolver }
  },
  {
    path: 'platform-switch',
    component: PlatformSwitchComponent,
    resolve: { theme: PlatformThemeResolver }
  },
  {
    path: 'platform-checkbox',
    component: PlatformCheckboxComponent,
    resolve: { theme: PlatformThemeResolver }
  },
  {
    path: 'platform-input',
    component: PlatformInputComponent,
    resolve: { theme: PlatformThemeResolver }
  },
  {
    path: 'platform-select',
    component: PlatformSelectComponent,
    resolve: { theme: PlatformThemeResolver }
  },
  {
    path: 'platform-progress-indicator',
    component: PlatformProgressIndicatorComponent,
    resolve: { theme: PlatformThemeResolver }
  },
  {
    path: 'platform-state-indicator',
    component: PlatformStateIndicatorComponent,
    resolve: { theme: PlatformThemeResolver }
  },
  {
    path: 'platform-status-marker',
    component: PlatformStatusMarkerComponent,
    resolve: { theme: PlatformThemeResolver }
  },
  {
    path: 'platform-action-ticker',
    component: PlatformActionTickerComponent,
    resolve: { theme: PlatformThemeResolver }
  },
  {
    path: 'platform-datepicker',
    component: PlatformDatepickerComponent,
    resolve: { theme: PlatformThemeResolver }
  },
  {
    path: 'platform-rangepicker',
    component: PlatformRangepickerComponent,
    resolve: { theme: PlatformThemeResolver }
  },
  {
    path: 'platform-message',
    component: PlatformMessageComponent,
    resolve: { theme: PlatformThemeResolver }
  },
  {
    path: 'platform-tabs',
    component: PlatformTabsComponent,
    resolve: { theme: PlatformThemeResolver }
  },
  {
    path: 'platform-radio',
    loadComponent: () => import('./platform-radio/platform-radio.component').then(m => m.PlatformRadioComponent),
    resolve: { theme: PlatformThemeResolver }
  },
  {
    path: 'platform-textarea',
    loadComponent: () => import('./platform-textarea/platform-textarea.component').then(m => m.PlatformTextareaComponent),
    resolve: { theme: PlatformThemeResolver }
  },

  {
    path: 'components',
    component: ComponentsComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: environment.production ? PreloadAllModules : NoPreloading,
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
